var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/internal/MarkdownTextWithToolTip/MarkDownTextWithToolTip.jsx";

import React from 'react';
import PropTypes from 'prop-types';
import { Paragraph, TriggerText, Popper, Text } from '@zillow/constellation';
import marked from 'marked';

var MarkDownTextWithToolTip = function MarkDownTextWithToolTip(_ref) {
  var markdownTextInput = _ref.markdownTextInput,
      bodyTooltipPopover = _ref.bodyTooltipPopover;
  // We divide the text into pre, popover text and post.
  var markdownTextParts = markdownTextInput.split(/{{(.+?)}}/g); // supports only 1 occurrence of {{}} hence the length check of 3

  if (markdownTextInput && bodyTooltipPopover && markdownTextParts.length === 3) {
    var triggerText = /*#__PURE__*/React.createElement(Popper, {
      triggered: bodyTooltipPopover,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 12,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(TriggerText, {
      dangerouslySetInnerHTML: {
        __html: marked.parseInline(markdownTextParts[1])
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 13,
        columnNumber: 17
      }
    }));
    return /*#__PURE__*/React.createElement(React.Fragment, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 21,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Text, {
      marginY: "sm",
      dangerouslySetInnerHTML: {
        __html: marked.parseInline(markdownTextParts[0])
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 22,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement(Text, {
      marginY: "sm",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 17
      }
    }, triggerText), /*#__PURE__*/React.createElement(Text, {
      marginY: "sm",
      dangerouslySetInnerHTML: {
        __html: marked.parseInline(markdownTextParts[2])
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 17
      }
    }));
  } // If we cannot identify a substring surrounded by "{{}}" in the passed in markdowntext
  // then we return a vanilla markdown text field below (default case)


  if (markdownTextInput) {
    return /*#__PURE__*/React.createElement(Paragraph, {
      marginY: "sm",
      dangerouslySetInnerHTML: {
        __html: marked.parseInline(markdownTextInput)
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 13
      }
    });
  }

  return null;
};

MarkDownTextWithToolTip.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The input text that could contain markdown. This text could optionally contain some
   * text within {{}} which is surrounded by the supplied popover element provided in the other
   * property [bodyToolTipPopover]
   */
  markdownTextInput: PropTypes.string,

  /**
   * The constructed popover that must be associated with the text within {{}}.
   * This is passed in externally to this component.
   */
  bodyTooltipPopover: PropTypes.element
} : {};
MarkDownTextWithToolTip.defaultProps = {
  markdownTextInput: '',
  bodyTooltipPopover: null
};
export { MarkDownTextWithToolTip };